
/**
 * useI18n
 * The custom hook which provided to external use via context
 */

import { useContext } from 'react'

import I18nContext from './i18n-context'

export default function useI18n() {
  const context = useContext(I18nContext)
  return context
}
